module.exports = __webpack_public_path__ + "static/media/dumpster-icon.00c28fed.svg";